import { AccountTeam } from '../AccountTeam.enum'

function getLabel(val: AccountTeam) {
  switch (val) {
    case AccountTeam.PRODUCT_AND_MARKETING:
      return 'Product & Marketing'
    case AccountTeam.ENGINEERING:
      return 'Engineering'
    default:
      return ''
  }
}

const AccountTeamEnumHelper = {
  getLabel,
}

export default AccountTeamEnumHelper
